/** Border / accent for audition detail field cards (matches Project Description treatment). */
export const AUDITION_FIELD_BORDER = '#FF9C28';
export const AUDITION_FIELD_ACCENT = '#FF9C28';
